import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { AccountingMissingDocumentResource } from "@exonn/js-sdk";

/**
 * "Fehlende / nicht zugeordnete Belege" (S6b, A19a): input-tax items of bookings
 * that have no document attached/assigned in exonn ERP yet. Read-only list; the only
 * action is attaching a document.
 */
export const module: ModuleOptions<AccountingMissingDocumentResource> = {
  resource: ResourceEnum.AccountingMissingDocument,
  bigIcon: <span className={"icon-20-document"} />,
  smallIcon: <span className={"icon-15-document"} />,
  disableCreate: true,
  disableDelete: true,
  tabs: {
    edit: {
      // Betrag in deutscher Schreibweise und ohne Vorzeichen, wie in der Liste. Der Titel
      // zeigte bisher den Rohwert der Datenbank: „· -119.000000".
      getTitle: (resource) =>
        `${resource.description ?? resource.posting_number ?? ""} · ${
          resource.gross_amount === null || resource.gross_amount === undefined
            ? ""
            : new Intl.NumberFormat("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(Math.abs(Number(resource.gross_amount)))
        }`,
    },
  },
};
